import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { notificationsService } from "@/services/notifications.service";

const notificationsKey = ["notifications"] as const;

export function useNotifications(enabled: boolean) {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: notificationsKey,
    queryFn: () => notificationsService.list(),
    enabled,
    refetchInterval: 60_000,
  });
  const markAsRead = useMutation({
    mutationFn: notificationsService.markAsRead,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notificationsKey }),
  });
  const markAllAsRead = useMutation({
    mutationFn: notificationsService.markAllAsRead,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notificationsKey }),
  });
  return { ...query, markAsRead, markAllAsRead };
}
